import { Text, HStack, VStack } from '@genial/components';
import { Typography } from '@genial/design-tokens';
import React from 'react';

import { EquityLastPrice } from '../EquityLastPrice';
import { EquityProductDisplay } from '../EquityProductDisplay';
import { ProductSectionProps } from '../ProductSection';

interface EquityMobileTitleProps extends ProductSectionProps {}

export const EquityMobileTitle: React.FC<EquityMobileTitleProps> = (props) => {
  return (
    <HStack flex={1} justifyContent={'space-between'}>
      <EquityProductDisplay
        src={props?.icons?.light}
        productName={props?.productName}
        symbol={props?.symbol}
      />
      <VStack>
        <Text variant="semibold" color={'neutral.black'} fontSize={Typography['fontsize.md']}>
          Último preço
        </Text>
        <EquityLastPrice
          lastPrice={props?.lastPrice}
          priceChangeTax={props?.priceChangeTax}
          tradeDate={props?.tradeDate}
        />
      </VStack>
    </HStack>
  );
};
